import React from 'react';
import {
  StyledHeader,
  StyledSubTitle,
  StyledTitle,
} from '@src/pages/workflow/components/Validation/Flow/styled';
const Header: React.FC = () => {
  return (
    <StyledHeader>
      <StyledTitle>Event Validation Report</StyledTitle>
      <StyledSubTitle>Sampled data of 24 hours.</StyledSubTitle>
    </StyledHeader>
  );
};

export default Header;
